export default __webpack_public_path__ + "static/media/image-head.99daacc3.png";